var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"list"},_vm._l((_vm.tablist),function(item,index){return _c('li',{key:index,staticClass:"item",class:index == _vm.current ? 'active' : '',on:{"click":function($event){return _vm.change(index, item)}}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }